import { BY_GENOME, BY_MUTATION, BY_MUTATION_BLOCK } from './common';

export class Layout {

  setData(variants, geneWedges, wedgeLookup) {
    this.variants = variants;
    this.geneWedges = geneWedges;
    this.wedgeLookup = wedgeLookup;
  }

  setCurrentMutations(currentMutations, currentMutationsLookup, threshold) {
    this.currentMutations = currentMutations;
    this.currentMutationsLookup = currentMutationsLookup;
    this.threshold = threshold;
  }

  setBySequence(bySequence, allowWildTypeOverride) {
    if (bySequence !== this.bySequence) {
      this.bySequence = bySequence;
      this.allowWildTypeOverride = allowWildTypeOverride;
      this.position();
    }
  }


  setDarkMode(darkMode) {
    this.darkMode = darkMode;
  }

  setIsMobile(isMobile) {
    this.isMobile = isMobile;
  }

  setSize(W, H) {
    this.W = W;
    this.H = H;
    this.cx = W * 0.5;
    this.cy = H * 0.5;
  }

  setHighlight(highlightGene, highlightMutation, highlightRing) {
    this.highlightGene = highlightGene;
    this.highlightMutation = highlightMutation;
    this.highlightRing = highlightRing;
  }


  highlightPrev() {
    if (this.highlightIndex > 0) {
      this.setMutationIndex(this.highlightIndex-1)
      // hgene = first.gene;
      // hpos = first.position;
      // hmut = closest.items;
      // hx = closest.x;
      // hindex = mIndex;
      return this.labelList[this.highlightIndex];
    }
  }

  highlightNext() {
    if (this.highlightIndex < this.labelList.length - 1) {
      this.setMutationIndex(this.highlightIndex+1)
      // hgene = first.gene;
      // hpos = first.position;
      // hmut = closest.items;
      // hx = closest.x;
      // hindex = mIndex;
      return this.labelList[this.highlightIndex];
    }
  }



  updateTicks() {
    let updating = false;
    if (this.labelList && this.geneWedges) {
      this.labelList.forEach(l=>updating = l.update() || updating);
      this.geneWedges.forEach(gw=>updating = gw.update() || updating);
    }
    return updating;
  }




  position() {
    switch (this.bySequence) {
    case BY_GENOME: this.positionBySequence(); break;
    case BY_MUTATION: this.positionByMutationName(this.allowWildTypeOverride); break;
    case BY_MUTATION_BLOCK: this.positionByMutationLocation(); break;
    }
  }



}